import type { UseInfiniteQueryResult } from '@tanstack/react-query'
import { useState } from 'react'
import { useUsersSearch } from '~/api/queries/user'
import { Dropdown } from '~/components/Form'
import type {
  DropdownOption,
  SingleDropdownProps
} from '~/components/Form/Input/Dropdown'

export const UsersAutocomplete = ({
  ids,
  listingContext,
  ...props
}: {
  ids?: string[]
  listingContext?: string
} & Omit<SingleDropdownProps, 'optionsInfiniteQuery' | 'options'>) => {
  const [search, setSearch] = useState<string>()
  const { data, ...rest } = useUsersSearch({
    ids: search !== undefined ? undefined : ids,
    search: search,
    listingContext
  })
  const options = data?.pages
    .flatMap((page) => page['hydra:member'])
    .map((user) => ({
      label: `${user.firstname} ${user.lastname}`,
      value: String(user.id)
    }))

  return (
    <Dropdown
      optionsInfiniteQuery={
        {
          ...rest,
          data: options
        } as unknown as UseInfiniteQueryResult<DropdownOption[] | undefined>
      }
      defaultValue={ids?.[0]}
      onSearchChange={setSearch}
      {...props}
    />
  )
}
